(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image-slideshow"] && !Shopify.designMode) return;
  try {
    class ImageSlideshow extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.timer = null;
      this.isTransitioning = false;
    }

    connectedCallback() {
      this.slides = this.querySelectorAll('.slideshow__slide');
      this.dots = this.querySelectorAll('.slideshow__dot');
      this.prevBtn = this.querySelector('.slideshow__arrow--prev');
      this.nextBtn = this.querySelector('.slideshow__arrow--next');

      if (this.slides.length === 0) return;

      // Initialize slide states
      this.slides.forEach((slide, i) => {
        if (i === this.currentIndex) {
          slide.classList.add('is-active');
          slide.style.visibility = 'visible';
          slide.style.transform = 'translateX(0)';
        } else {
          slide.classList.remove('is-active');
          slide.style.visibility = 'hidden';
          slide.style.transform = 'translateX(100%)';
        }
      });

      if (this.slides.length <= 1) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prevSlide());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.nextSlide());

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.getAttribute('data-dot-index'));
          this.goToSlide(index);
        });
      });

      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      const autoplay = this.getAttribute('data-autoplay') === 'true';
      const speed = parseInt(this.getAttribute('data-speed')) || 5000;

      if (autoplay && speed > 0) {
        this.timer = setInterval(() => this.nextSlide(), speed);
      }
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    goToSlide(index, direction) {
      if (index === this.currentIndex || this.isTransitioning) return;
      
      const slides = Array.from(this.slides);
      if (slides.length <= 1) return;

      this.isTransitioning = true;
      const targetIndex = (index + slides.length) % slides.length;
      const currentSlide = slides[this.currentIndex];
      const nextSlide = slides[targetIndex];

      // Determine sliding direction
      if (!direction) {
        direction = targetIndex > this.currentIndex ? 'next' : 'prev';
        if (targetIndex === 0 && this.currentIndex === slides.length - 1) direction = 'next';
        if (targetIndex === slides.length - 1 && this.currentIndex === 0) direction = 'prev';
      }

      // 1. Prepare incoming slide without transition
      nextSlide.style.transition = 'none';
      nextSlide.style.transform = direction === 'next' ? 'translateX(100%)' : 'translateX(-100%)';
      nextSlide.style.visibility = 'visible';

      // Force layout calculation
      nextSlide.offsetHeight;

      // 2. Animate both slides
      const transitionStyle = 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), visibility 0.6s';
      currentSlide.style.transition = transitionStyle;
      nextSlide.style.transition = transitionStyle;

      currentSlide.style.transform = direction === 'next' ? 'translateX(-100%)' : 'translateX(100%)';
      nextSlide.style.transform = 'translateX(0)';

      // Update active classes
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      // Update dot active classes
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === targetIndex);
      });

      // Cleanup when transition completes
      setTimeout(() => {
        if (this.currentIndex === targetIndex) {
          slides.forEach((slide, i) => {
            if (i !== targetIndex) {
              slide.style.visibility = 'hidden';
              slide.style.transform = 'translateX(100%)';
              slide.style.transition = 'none';
            }
          });
        }
        this.isTransitioning = false;
      }, 600);

      this.currentIndex = targetIndex;
      this.startAutoplay();
    }

    nextSlide() {
      this.goToSlide(this.currentIndex + 1, 'next');
    }

    prevSlide() {
      this.goToSlide(this.currentIndex - 1, 'prev');
    }
  }

  if (!customElements.get('image-slideshow')) {
    customElements.define('image-slideshow', ImageSlideshow);
  }
  } catch(e) { console.error(e); }
})();

})();
